import { Button, Container } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import styled from 'styled-components';

const NotFoundContainer = styled.div`
    margin-top: 70px;
    height: calc(100vh - 72px - 60px);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    width: 40%;
    text-align: center;

    @media (max-width: 767px) {
        width: 100%;
    }
`;

const PageNotFound = () => {
    return <NotFoundContainer>
        <div style={{ padding: '15px' }}>
            <h1 style={{ fontWeight: 900 }}>Sorry,</h1>
            <h2>couldn't find the page.</h2>

            <p>
                It seems the page you were trying to access isn't there.  Perhaps there is a typo, so please check the URL and if you are attempting to view a creator profile, it is possible that this creator is no longer available or a typo.
            </p>

            <Button
                variant='contained'
                sx={{ borderRadius: '20px', marginTop: '20px' }}
                onClick={() => window.location.href = '/home'}
            >
                <strong><i className="fa-solid fa-chevron-left" style={{ marginRight: '8px' }}></i> Go back to homepage</strong>
            </Button>
        </div>
    </NotFoundContainer>;
};

export default PageNotFound;